import React from 'react';
import { ReactComponent as ArrowDownRight } from 'src/assets/icons/arrowDownRight.svg';
import { ReactComponent as ArrowUpRight } from 'src/assets/icons/arrowUpRight.svg';

export const getBadgeIconForTrend = (variant: string) => {
  switch (variant) {
    case 'positive':
      return <ArrowUpRight />;
    case 'negative':
      return <ArrowDownRight />;
    default:
      return null;
  }
};
